import React, { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import jsPDF from "jspdf";
import { Row, Modal, Form } from "reactstrap";
import SignatureCanvas from "react-signature-canvas";
import zithasLogo from "../../../assets/images/zithas-dark-logo.png";
import axios from "axios";
import Loader from "pages/Separate/Loader";
import moment from "moment";
import configure from "configure";
import Swal from "sweetalert2";
import html2canvas from "html2canvas";
import Contract from "../../../assets/css/Sales/Contract.css"

const SignContractAmendment = () => {
  const [fixedRightSec, setFixedRightSec] = useState(false);
  const [modal_center, setmodal_center] = useState(false);
  const [attachmentModal, setAttachmentModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setFixedRightSec(window.scrollY > 48);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const printContract = () => {
    let printContents = document.getElementById("zithasInvoicePrint").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  const pdfRef = useRef();

  const generatePDF = async () => {
    try {
      setLoading(true);
      const pdf = new jsPDF("p", "mm", "a4");
      const element = pdfRef.current;
      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL("image/png");
      const width = pdf.internal.pageSize.getWidth();
      const height = (canvas.height * width) / canvas.width;
      const totalPages = Math.ceil(height / pdf.internal.pageSize.getHeight());
      for (let page = 0; page < totalPages; page++) {
        if (page > 0) pdf.addPage();
        const startY = page * pdf.internal.pageSize.getHeight();
        pdf.addImage(imgData, "PNG", 0, -startY, width, height);
      }
      pdf.save(`Amendment-${amendment_no}.pdf`);
      setLoading(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
      setLoading(false);
    }
  };

  const params = useParams();
  const [isLoading, setLoading] = useState(false);
  const [expire, setExpire] = useState();

  // ── Amendment-specific state ──────────────────────────────────────────
  const [document_html, setDocumentHtml] = useState("");
  const [amendment_no, setAmendmentNo] = useState("");
  const [amendment_ref, setAmendmentRef] = useState("");
  const [company_name, setCompanyName] = useState("");
  const [currency_symbol, setCurrencySymbol] = useState("");
  const [fee_change, setFeeChange] = useState("");
  const [fee_direction, setFeeDirection] = useState("");
  const [hours_change, setHoursChange] = useState("");
  const [revised_end_date, setRevisedEndDate] = useState("");
  const [effective_date, setEffectiveDate] = useState("");
  const [amendment_id, setAmendmentId] = useState("");
  // ─────────────────────────────────────────────────────────────────────

  const [attachment, setAttachment] = useState("");

  useEffect(() => {
    fetchAmendment();
  }, []);

  // ── CHANGED: fetch from Node amendment endpoint instead of Laravel ──
  const fetchAmendment = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${configure.nodeApi}/contract_amendment/show/${params.id}`,
      );
      if (response.data.success === true) {
        const a = response.data.data;
        setExpire(false);
        setAmendmentId(a.id);
        setDocumentHtml(a.document_html || "");
        setAmendmentNo(a.amendment_no || "");
        setAmendmentRef(a.amendment_ref || "");
        setCompanyName(a.company_name || "");
        setCurrencySymbol(a.currency_symbol || "£");
        setFeeChange(a.fee_change || "");
        setFeeDirection(a.fee_direction || "add");
        setHoursChange(a.hours_change || "");
        setRevisedEndDate(a.revised_end_date || "");
        setEffectiveDate(a.effective_date || "");
      } else {
        // "already signed" or "not ready" — show expired screen
        setExpire(true);
      }
    } catch (err) {
      console.log(err);
      setExpire(true);
    } finally {
      setLoading(false);
    }
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const signatureRef = useRef(null);
  const [signatureDraw, setSignatureDraw] = useState([]);
  const [signature, setSignature] = useState("");

  useEffect(() => {
    if (signatureDraw.length && signatureRef.current) {
      signatureRef.current.fromData(signatureDraw);
    }
  }, [signatureDraw]);

  useEffect(() => {
    const handleResize = () => {
      if (signatureDraw.length && signatureRef.current) {
        signatureRef.current.fromData(signatureDraw);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [signatureDraw]);

  // ── CHANGED: POST to Node sign endpoint instead of Laravel ──
  const handleSave = async (e) => {
    e.preventDefault();
    if (signatureRef.current?.isEmpty()) {
      Swal.fire({ icon: "warning", text: "Signature Required!" });
      return;
    }
    const signatureImage = signatureRef.current.toDataURL();

    Swal.fire({
      title: "Are you sure?",
      text: "You Want to Sign this Amendment!",
      icon: "warning",
      showCancelButton: true,
    }).then(async (willSign) => {
      if (!willSign.isConfirmed) return;
      setLoading(true);
      try {
        const response = await axios.post(
          `${configure.nodeApi}/contract_amendment/sign/${params.id}`,
          { name, email, signature: signatureImage },
        );
        if (response.data.success === true) {
          Swal.fire({
            icon: "success",
            text: "Thanks for signing the Amendment!",
          }).then(() => {
            setmodal_center(false);
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "warning",
            text: response.data?.message || "Something went wrong.",
          });
        }
      } catch (err) {
        Swal.fire({ icon: "error", text: "Something went wrong." });
      } finally {
        setLoading(false);
      }
    });
  };

  const handleClear = () => signatureRef.current.clear();

  // ── Attachment upload (same as original) ─────────────────────────────
  const handleAttachmentSave = async (e) => {
    e.preventDefault();
    if (!attachment?.length) {
      Swal.fire({ icon: "warning", text: "Signature attachment is required!" });
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You Want to Sign this Amendment!",
      icon: "warning",
      showCancelButton: true,
    }).then(async (willSign) => {
      if (!willSign.isConfirmed) return;
      setLoading(true);
      try {
        const response = await axios.post(
          `${configure.nodeApi}/contract_amendment/sign/${params.id}`,
          { name, email, signature: attachment },
        );
        if (response.data.success === true) {
          Swal.fire({
            icon: "success",
            text: "Thanks for signing the Amendment!",
          }).then(() => {
            setName("");
            setEmail("");
            setAttachmentModal(false);
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "warning",
            text: response.data?.message || "Something went wrong.",
          });
        }
      } catch (err) {
        Swal.fire({ icon: "error", text: "Something went wrong." });
      } finally {
        setLoading(false);
      }
    });
  };

  const handleToBase24 = (e) => {
    if (
      e.target.files[0].type === "image/jpeg" ||
      e.target.files[0].type === "image/png"
    ) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setAttachment(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    } else {
      Swal.fire("", "Only JPG and PNG images can be uploaded!", "warning");
    }
  };

  const handleEnd = () => {
    if (!signatureRef.current.isEmpty()) {
      setSignatureDraw(signatureRef.current.toData());
    }
  };

  // ── RENDER ────────────────────────────────────────────────────────────

  if (expire === false) {
    return (
      <React.Fragment>
        {isLoading && <Loader />}
        <div className="page-content mb-2" style={{ paddingTop: "60px" }}>
          <Container fluid>
            <Row>
              {/* ── Document panel ── */}
              <div className="col-md-9 col-12 ps-md-0 order-md-1 order-2">
                <div
                  id="zithasInvoicePrint"
                  className="bg-white p-3 shadow document"
                  ref={pdfRef}
                  style={{
                    // padding: "1in 1in",
                    padding: "148px 156px",
                    boxSizing: "border-box",
                  }}
                >
                  <div className="pb-2 text-center">
                    <img src={zithasLogo} height="60" alt="zithasLogo" />
                  </div>

                  {/* Amendment badge */}
                  <div className="text-center mb-3">
                    <span
                      className="badge"
                      style={{
                        background: "#752a97",
                        color: "#fff",
                        fontSize: "13px",
                        padding: "6px 16px",
                        borderRadius: "20px",
                      }}
                    >
                      Contract Amendment · {amendment_ref || amendment_no}
                    </span>
                  </div>

                  <div>
                    {/* ── CHANGED: render document_html from amendment ── */}
                    <div
                      style={{ textAlign: "justify" }}
                      className="Features"
                      dangerouslySetInnerHTML={{
                        __html: document_html
                          .replaceAll("{", "")
                          .replaceAll("}", ""),
                      }}
                    />

                    {/* <h5 className="fw-bold text-decoration-underline mt-4">
                      Effective Date :{" "}
                      {effective_date
                        ? moment(effective_date).format("DD-MM-YYYY")
                        : "-"}
                    </h5> */}

                    {/* Signature placeholder */}
                    {/* <Row className="mt-4 justify-content-end">
                      <div className="col-4">
                        {signature?.length === 0 || !signature ? (
                          <div className="sign-box">Signature</div>
                        ) : (
                          <img src={signature} height="50" className="mb-2" />
                        )}
                        <h5 className="mb-1">For {company_name}</h5>
                      </div>
                    </Row> */}
                  </div>
                </div>
              </div>

              {/* ── Right panel ── */}
              <div className="col-md-3 col-12 pe-md-0 order-md-2 order-1 mb-md-0 mb-3">
                <div
                  className={`${
                    fixedRightSec ? "fixed-right-section top-0" : ""
                  }`}
                >
                  {/* Action buttons */}
                  <div className="col-12 text-md-end text-center">
                    <button
                      onClick={printContract}
                      className="btn btn-sm btn-success border-radius me-1"
                    >
                      <i className="fas fa-print me-1"></i> Print
                    </button>
                    <button
                      onClick={() => setmodal_center(true)}
                      className="btn btn-sm btn-primary border-radius me-1"
                    >
                      <i className="fas fa-file-signature me-1"></i> Signature
                    </button>
                    <button
                      onClick={generatePDF}
                      className="btn btn-sm btn-secondary border-radius"
                    >
                      <i className="fas fa-file-download me-1"></i> Download
                    </button>
                  </div>

                  {/* ── CHANGED: Amendment summary instead of contract summary ── */}
                  <div className="bg-white p-3 mt-4 shadow">
                    <h5 className="mb-3 text-dark">
                      Amendment: {amendment_ref || amendment_no}
                    </h5>
                    {fee_change && Number(fee_change) > 0 && (
                      <h6 className="mb-3">
                        Fee Change:{" "}
                        <span
                          style={{
                            color:
                              fee_direction === "add" ? "#34c38f" : "#f46a6a",
                            fontWeight: 600,
                          }}
                        >
                          {fee_direction === "add" ? "+" : "-"}
                          {currency_symbol}
                          {Number(fee_change).toLocaleString()}
                        </span>
                      </h6>
                    )}
                    {hours_change && Number(hours_change) > 0 && (
                      <h6 className="mb-3">
                        Hours Change:{" "}
                        <span style={{ fontWeight: 600 }}>
                          {Number(hours_change)} hrs
                        </span>
                      </h6>
                    )}
                    {revised_end_date && (
                      <h6 className="mb-3">
                        Revised Completion:{" "}
                        {moment(revised_end_date).format("DD MMM YYYY")}
                      </h6>
                    )}
                    {effective_date && (
                      <h6 className="mb-3">
                        Effective Date:{" "}
                        {moment(effective_date).format("DD MMM YYYY")}
                      </h6>
                    )}
                  </div>

                  {/* Attachment upload option */}
                  <div className="bg-white p-3 mt-4 shadow">
                    <p className="text-danger" style={{ fontSize: "12px" }}>
                      * If you encounter issues signing, please sign on paper,
                      scan it and upload below.
                    </p>
                    <button
                      onClick={() => setAttachmentModal(true)}
                      className="btn btn-sm btn-primary border-radius py-2 w-100"
                    >
                      <i className="fas fa-file-signature me-1"></i> Attach Your
                      Signature
                    </button>
                  </div>
                </div>
              </div>
            </Row>
          </Container>
        </div>

        {/* ── Signature draw modal (unchanged from original) ── */}
        <Modal
          isOpen={modal_center}
          toggle={() => setmodal_center(false)}
          centered
          size="lg"
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">
              Signature &amp; Confirmation Of Identity
            </h5>
            <button
              type="button"
              onClick={() => setmodal_center(false)}
              className="btn-modal-close"
            >
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleSave}>
              <Row>
                <div className="col-md-5 mb-3">
                  <label htmlFor="">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    className="form-control"
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-5 mb-3">
                  <label htmlFor="">
                    Email Address <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    className="form-control"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="">
                    Signature <span className="text-danger">*</span>
                  </label>
                  <SignatureCanvas
                    ref={signatureRef}
                    penColor="black"
                    onEnd={handleEnd}
                    canvasProps={{
                      className: "sigCanvas border",
                      style: {
                        width: "100%",
                        height: "200px",
                        touchAction: "none",
                        backgroundColor: "white",
                      },
                    }}
                  />
                </div>
              </Row>
              <div className="border-bottom my-3"></div>
              <div className="text-end">
                <a className="btn btn-red btn-label me-2" onClick={handleClear}>
                  <i className="bi bi-x-circle label-icon"></i> Clear Signature
                </a>
                <button className="btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i> Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>

        {/* ── Attachment modal (unchanged from original) ── */}
        <Modal isOpen={attachmentModal} centered size="md">
          <div className="modal-header">
            <h5 className="modal-title mt-0">Attach Your Signature</h5>
            <button
              type="button"
              onClick={() => setAttachmentModal(false)}
              className="btn-modal-close"
            >
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form onSubmit={handleAttachmentSave}>
              <Row>
                <div className="col-md-6 mb-3">
                  <label htmlFor="">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    className="form-control"
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="">
                    Email Address <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    className="form-control"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="">
                    Signature Attachment <span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={handleToBase24}
                  />
                </div>
                {attachment && (
                  <div>
                    <img src={attachment} alt="preview" height="80px" />
                  </div>
                )}
              </Row>
              <div className="border-bottom my-3"></div>
              <div className="text-end">
                <button className="btn btn-save btn-label" type="submit">
                  <i className="fas fa-save me-2 label-icon"></i> Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>
      </React.Fragment>
    );
  } else if (expire === true) {
    // ── Already signed / expired screen (same as original) ──
    return (
      <section className="my-5 pt-sm-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div className="home-wrapper">
                <div className="mb-5">
                  <img src={zithasLogo} className="" height="100" alt="logo" />
                </div>
                <div className="justify-content-center row">
                  <div className="col-sm-4">
                    <div className="maintenance-img">
                      <img
                        src="/static/media/maintenance.938d28ce46a03edf5d9303e67f1d2028.svg"
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </div>
                </div>
                <h1 className="pt-5">Thanks for signing the Amendment</h1>
                <h5 className="mt-2">We'll be in touch shortly.</h5>
                <div className="mt-5">
                  <button
                    className="border-radius btn text-white me-2 btn-purple"
                    onClick={() => window.close()}
                  >
                    <i className="dripicons-cross me-2 icon-center"></i>
                    Close Browser Tab
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    return <Loader />;
  }
};

export default SignContractAmendment;
